import LogoMarquee from '@/components/ui/LogoMarquee';
import SectionHeading from '@/components/site/SectionHeading';
import { useClients } from '@api/public';

export default function ClientsStrip({ eyebrow, title }) {
  const logos = useClients();
  const half = Math.ceil(logos.length / 2);
  return (
    <section className="overflow-hidden bg-ink-50 py-16 sm:py-24">
      <div className="site-container">
        <SectionHeading eyebrow={eyebrow} title={title} align="center" />
      </div>
      <div className="mt-10 space-y-4">
        <LogoMarquee logos={logos.slice(0, half)} />
        <LogoMarquee logos={logos.slice(half)} reverse={false} duration={90} />
      </div>
    </section>
  );
}
